<template>
    <div
        class="slt-max-content-center slt-gsap-teams slt-padding-box flex flex-col gap-14 pb-20 pt-[132px] sm:pb-[120px] sm:pt-[160px] lg:flex-row lg:justify-between lg:pb-40"
    >
        <AtomsH2
            class="flex-shrink-0 text-left"
            v-if="shouldRender(teams?.title)"
        >
            <BaseFormatText2 ref="titleText" :text="teams?.title" type="span" />
        </AtomsH2>

        <div class="flex flex-col gap-16 lg:min-w-[920px] lg:gap-[120px]">
            <MoleculesTeam
                v-for="(team, idx) in teams?.data"
                :key="idx"
                :team="team"
            />
        </div>
    </div>
</template>

<script setup>
import { useGtag } from "vue-gtag-next";
import { shouldRender } from "~/lib/utils";
import { organismTeamsAnimate } from "@/lib/gsap-about";
import { textSplitAnimate, killAnimation } from "@/lib/gsap-core";
const { teams } = defineProps({
    teams: {
        type: Object,
        required: true,
    },
});

const { event } = useGtag();

const titleText = ref(null);
let tl = null;
onMounted(() => {
    tl = organismTeamsAnimate(
        () => textSplitAnimate(false, titleText, 0.5),
        () =>
            event("user_engagement", {
                event_category: "about",
                event_label: "領導團隊",
            }),
    );
});
onBeforeUnmount(() => {
    killAnimation(tl);
});
</script>
